import React from 'react';
import PropTypes from 'prop-types';
import SearchRow from '../../components/SearchRow';
import loadable from '@loadable/component';

const QuickLinksFragment = loadable(() =>
  import('../../components/QuickLinksFragment')
);

const SearchPage = ({ deviceInfo = {}, ...props }) => {
  const {
    toolTileProps: {
      app: { context: { user: { isLoggedIn } = {} } = {} } = {}
    } = {}
  } = props;
  return (
    <div id="appcenter-main">
      <div id="appcenter-categories">
        <SearchRow {...props} />
      </div>
      {deviceInfo.isDesktop && isLoggedIn === true && <QuickLinksFragment />}
    </div>
  );
};

SearchPage.displayName = 'search';

SearchPage.propTypes = {
  fptiClick: PropTypes.func,
  appSearch: PropTypes.object,
  flatPSData: PropTypes.object,
  toolTileProps: PropTypes.object,
  deviceInfo: PropTypes.object
};

export default SearchPage;
